var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowUp = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.51 21.86",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "black arrow up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25,20.36V5L13,8.56a1.5,1.5,0,0,0,2.12-.05,1.48,1.48,0,0,0,.42-1A1.51,1.51,0,0,0,15,6.39L8.79.42a1.49,1.49,0,0,0-2.07,0l-6.26,6a1.49,1.49,0,0,0,0,2.12,1.5,1.5,0,0,0,2.12.05L6.25,5V20.36a1.5,1.5,0,0,0,3,0Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowUp);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNS41MSAyMS44NiI+PHRpdGxlPmJsYWNrIGFycm93IHVwPC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwYXRoIGQ9Ik05LjI1LDIwLjM2VjVMMTMsOC41NmExLjUsMS41LDAsMCwwLDIuMTItLjA1LDEuNDgsMS40OCwwLDAsMCwuNDItMUExLjUxLDEuNTEsMCwwLDAsMTUsNi4zOUw4Ljc5LjQyYTEuNDksMS40OSwwLDAsMC0yLjA3LDBsLTYuMjYsNmExLjQ5LDEuNDksMCwwLDAsMCwyLjEyLDEuNSwxLjUsMCwwLDAsMi4xMi4wNUw2LjI1LDVWMjAuMzZhMS41LDEuNSwwLDAsMCwzLDBaIi8+PC9nPjwvZz48L3N2Zz4=";